import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDesktopLayout } from '../../../layout/useDesktopLayout';
import { displayManagePath } from './displayManageRoutes';

type OpenDisplayManage = (screenId: string, options?: { playContent?: boolean }) => void;

type UseOpenDisplayManageOptions = {
  /** Desktop sheet opener — only used at `lg+`. */
  onDesktopOpen: OpenDisplayManage;
};

/**
 * Mobile → dedicated `/screens/:id` page.
 * Desktop → existing manage sheet callback.
 */
export function useOpenDisplayManage({
  onDesktopOpen,
}: UseOpenDisplayManageOptions): OpenDisplayManage {
  const isDesktop = useDesktopLayout();
  const navigate = useNavigate();

  return useCallback(
    (screenId, options) => {
      if (isDesktop) {
        onDesktopOpen(screenId, options);
        return;
      }
      navigate(displayManagePath(screenId, options));
    },
    [isDesktop, navigate, onDesktopOpen],
  );
}
